import LINKS from "@/lib/links";
import { Component } from "@builder.io/sdk";

export const textCardGroupConfig: Component = {
  name: "Text Card Group",
  inputs: [
    {
      name: "id",
      type: "string",
      defaultValue: "our-care-solutions",
      helperText:
        "Unique identifier for the section. Useful for linking to the section by '#id'.",
      advanced: true,
    },
    {
      name: "heading",
      type: "string",
      defaultValue: "Our Care Solutions",
      helperText: "Heading for the section",
    },
    {
      name: "description",
      type: "longText",
      friendlyName: "Subheading",
      defaultValue: "We create personalized care plans to match your needs.",
      helperText: "Subheading for the section",
    },
    {
      name: "overrideColumns",
      type: "boolean",
      defaultValue: false,
      advanced: true,
    },
    {
      name: "numOfColumnsLg",
      type: "number",
      defaultValue: 4,
      advanced: true,
      showIf: (options) => options.get("overrideColumns"),
    },
    {
      name: "numOfColumnsMd",
      type: "number",
      defaultValue: 3,
      advanced: true,
      showIf: (options) => options.get("overrideColumns"),
    },
    {
      name: "numOfColumnsSm",
      type: "number",
      defaultValue: 2,
      advanced: true,
      showIf: (options) => options.get("overrideColumns"),
    },
    {
      name: "items",
      type: "list",
      friendlyName: "Cards",
      helperText: "Cards to display in the section",
      onChange: (options) => {
        if (options.get("items").length > 6) {
          options.set("items", options.get("items").slice(0, 6));
          alert("You can only add up to 6 cards");
        }
      },
      subFields: [
        {
          name: "className",
          type: "string",
        },
        {
          name: "title",
          type: "string",
          required: true,
        },
        {
          name: "items",
          type: "string",
          friendlyName: "Card Items",
          helperText:
            "List of Items for the card (CSV Format, ie. Item1,Item2,Item3)",
        },
        {
          name: "children",
          type: "richText",
          friendlyName: "Card Description",
          helperText: "Description text for the card",
        },
        {
          name: "href",
          friendlyName: "Card Link",
          helperText: "ie. https://careindeed.com/some-url or /some-url",
          type: "string",
          required: true,
        },
        {
          name: "overrideButton",
          type: "boolean",
          defaultValue: false,
          helperText: "Override the default button",
        },
        {
          name: "button",
          friendlyName: "Card Button",
          type: "object",
          showIf: "options.get('overrideButton') === true",
          subFields: [
            {
              name: "color",
              type: "string",
              friendlyName: "Button Color",
              defaultValue: "teal",
              enum: ["orange", "teal"],
            },
            {
              name: "href",
              friendlyName: "Button Link",
              type: "string",
              required: true,
            },
            {
              name: "children",
              type: "string",
              friendlyName: "Button Text",
              helperText: "Button text",
              defaultValue: "Learn more",
              required: true,
            },
          ],
          defaultValue: {
            color: "teal",
            children: "Learn more",
          },
        },
      ],
      defaultValue: [
        {
          title: "Home Care",
          type: "items",
          items: [
            "Live-in and 24-hour Care",
            "Hourly Care",
            "Medication Management",
          ],
          button: {
            color: "teal",
            children: "Learn more",
          },
          href: LINKS.homeCare.href,
        },
        {
          type: "text",
          title: "1:1 Hospital Sitter",
          children:
            "Care Indeed's one-on-one hospital sitters provide dedicated, around-the-clock support to ensure your or your loved one is well-cared for during their hospital stay. Our sitters offer companionship, assistance, and continuous monitoring to promote healing, reduce infection risks, and prevent injuries or falls. Focusing on supplementary care, they engage in conversation, reading, playing games, and simply being present.",
          href: LINKS.hospitalSitterService.href,
        },
        {
          type: "items",
          title: "Long-term Care",
          items: ["Personal Concierge", "72-Hour Post-Discharge"],
          button: {
            color: "teal",
            children: "Learn more",
          },
          href: LINKS.longTermCareService.href,
        },
        {
          title: "Private Duty Medical Care",
          type: "items",
          items: [
            "Skilled Nursing",
            "Physical Therapy",
            "Occupational Therapy",
          ],
          button: {
            color: "teal",
            children: "Learn more",
          },
          href: LINKS.homeHealthCare.href,
        },
        {
          title: "Specialized Care",
          type: "items",
          items: ["Hospital to Home", "Hospice and Palliative Care"],
          button: {
            color: "teal",
            children: "Learn more",
          },
          href: LINKS.specializedCare.href,
        },
        {
          title: "Disease Specialties",
          type: "items",
          items: [
            "Alzheimer's & Other Dementias",
            "Post Stroke",
            "Parkinson's Care",
            "Diabetes",
          ],
          button: {
            color: "teal",
            children: "Learn more",
          },
          href: LINKS.diseaseSpecialties.href,
        },
      ],
    },
  ],
};
